// extracted by mini-css-extract-plugin
export var label = "_d6-1";
export var reminder = "_d6-0";